import moment from "moment"

import {CelebrationsReportDuration} from "@irati/types"

const buildAvailableDatesSelectOptions = (availableDates, formatMessage) => {
  const [, ...previousMonths] = availableDates
  return [
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last30Days"}),
      value: CelebrationsReportDuration.CelebrationsLast_30Days
    },
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last90Days"}),
      value: CelebrationsReportDuration.CelebrationsLast_90Days
    },
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last12Months"}),
      value: CelebrationsReportDuration.CelebrationsLast_12Months
    },
    ...previousMonths.slice(0, 12).map((value) => {
      return {
        label: `${moment.months(value.month - 1)} '${value.year.toString().substring(2)}`,
        value: `${value.month}-${value.year}`
      }
    })
  ]
}

export default buildAvailableDatesSelectOptions
